export default {
  "home": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upsilon File Exchanger for NumWorks"])},
    "connect": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connect"])},
    "disconnect": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Disconnect"])},
    "delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete"])},
    "rename": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rename"])},
    "rename-prompt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter new name:"])},
    "download": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download"])},
    "download-all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download all"])},
    "records": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Files"])},
    "upload": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upload"])},
    "size": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Size"])},
    "bytes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["bytes"])}
  },
  "about": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["About"])},
    "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upsilon File Exchanger for NumWorks is a web application that allows you to manage your Numworks from your browser."])},
    "github": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GitHub"])}
  },
  "error": {
    "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error :"])},
    "unknown": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An unknown error has occurred."])},
    "no-usb": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your browser does not support WebUSB, please use a Chromium-based browser instead."])}
  }
}